import NotificationViewState from '../store/schema/NotificationViewState';
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';

let nextId = 0;

export default action('addNotification')(function addNotification(
    notificationViewState: NotificationViewState
) {
    let notification = {
        id: nextId++,
        ...notificationViewState,
    };
    store.notificationViewStates.push(notification);
});
